import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Autocomplete, FormControlLabel, Checkbox
} from "@mui/material";
import { useFormik } from "formik";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useGetAllSearchCompanyQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetPriceHistoryQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useUpdateInvoiceStatusQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import {
  ICompanyDetails,
  ICustomer,
  IPriceHistoryPayload,
  IProductPopUP,
  ITaxes,
} from "../../../Api/Interface/api.interface";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toDate } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import {
  ProductType,
  TransferType,
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import NewCompanyPopUp from "../../CompanyInfo/Components/NewCompanyPopUp";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
  TimePicker
} from "@mui/x-date-pickers";
import { uploadImage } from "../../../Components/UploadFile/upload";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import { useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import placeholderImage from '../../../Images/fav.png';
import { City } from "country-state-city";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DeleteIcon from "@mui/icons-material/Delete";
import { CANADIAN_CITIES } from "../../../Core/Data/canadianCities";

dayjs.extend(utc);
dayjs.extend(timezone);

const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `WO${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

interface IProduct {
  productName: string;
  productDescription: string;
  productImg: String | null;
  numberOfPassengers: number | null;
  busCount: number | null
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  transferTypeDescription: string;
  departureDateTime: Dayjs | null;
  returnDateTime: Dayjs | null;
  departureAddress: string;
  destinationAddress: string;
  multiDestination: string;
  quantity: number | null;
  price: number | null;
  tax: number;
  taxAmount: number;
  total: number;
  taxId: number | null;
  unitPriceWithDiscount: number | null;
  unitTotalWithDiscount: number;
  productType: string;
  productLongDescription: string;
  productShortDescription: string;
  pickups?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  dropoffs?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  returnPickups?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  returnDropoffs?: { address: string; city: string; dateTime: dayjs.Dayjs | null }[];
  useSameAsOutbound?: boolean;
}

interface IDiscount {
  value: number | null;
  description: string;
}

interface IProduct {
  productName: string;
  transferTypeTo: string;
  transferTypeFrom: string;
}

const Index: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [newTax, { isLoading }] = useCreateWorkOrderMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: customerId } = useParams<{ id: string }>();

  // const [searchQuery, setSearchQuerffy] = useState<string>("");
  // const [currentSearchQuery, setCurrentSearchQuery] = useState<string>("");
  // const debouncedSearchQuery = useDebounce(searchQuery, 300);
  // const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const debouncedSearchQueryCustomer = useDebounce(searchQueryCustomer, 300);
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);

  const [searchQueryProduct, setSearchQueryProduct] = useState<string>("");
  const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =
    useState<string>("");
  const debouncedSearchQueryProduct = useDebounce(searchQueryProduct, 300);
  const [showDropdownProductIndex, setShowDropdownProductIndex] = useState<
    number | null
  >(null);

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const [selectedDefultCompanyId, setSelectedDefultCompanyId] =
    useState<string>("");

  const [averagePrice, setAveragePrice] = useState<number | null>(null);
  const [nextPrice, setNextPrice] = useState<number | null>(null);
  const [quoteWorkOrderNo, setQuoteWorkOrderNo] = useState<String | null>(null);
  const [updated_at, setUpdated_at] = useState<Date | null>(null);
  const [priceId, setPriceId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [openD, setOpenD] = useState(false);
  const [id, setId] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const [currentPriceQueryParams, setCurrentPriceQueryParams] =
    useState<IPriceHistoryPayload | null>(null);

  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  const [originalProduct, setOriginalProduct] = useState<IProduct | null>(null); 
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [canadianCities, setCanadianCities] = useState<string[]>([]); 
  const [busCount, setBusCount] = useState<number | null>(null);
  const [errors, setErrors] = useState<{ departureDateTime?: string; returnDateTime?: string }>({});
  const [taxAmount, setTaxAmount] = useState<number>(0);

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024; // 2 MB

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        return;
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        return;
      } else {
        try {
          setIsImageUploading(true);
          const uploadedImageUrl = await uploadImage(file);
          const updatedRows = [...productRows];
          updatedRows[index].productImg = uploadedImageUrl;
          setProductRows(updatedRows);
          setIsImageUploading(false);
        } catch (error) {
          showErrorMessage("Failed to upload the image.");
          setIsImageUploading(false);
        }
      }
    }
  };

  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });

  const taxList = useMemo(() => {
    return taxData?.data as ITaxes[];
  }, [taxData?.data]);

  // const defaultTax = useMemo(() => {
  //   const foundDefaultTax = taxList.find((tax) => tax.isDefault === true);
  //   return foundDefaultTax ? foundDefaultTax : taxList[0] || null;
  // }, [taxList]);

  const [productRows, setProductRows] = useState<IProduct[]>([]);

  const [discounts, setDiscounts] = useState<IDiscount[]>([]);

  // const [discounts, setDiscounts] = useState<IDiscount[]>([
  //   { value: null, description: "" },
  // ]);
  const [discountValue, setDiscountValue] = useState<number>(0);
  const [discountDescription, setDiscountDescription] = useState<string>("");
  const [subTotal, setSubTotal] = useState<number>(0);
  const [totalDiscount, setTotalDiscount] = useState<number>(0);
  const [grandTotal, setGrandTotal] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [unitPrice, setUnitPrice] = useState<number>(0);
  const [grandTotalEithDiscount, setGrandTotalWithDiscount] =
    useState<number>(0);

  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState<string | null>(
    null
  );
  const [openCompany, setOpenCompany] = useState(false);
  const [poNumber, setPoNumber] = useState("");
  const {
    data: companyData,
    isLoading: companyIsLoading,
    isError,
    refetch,
  } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });

  const { data: workOrderLastData, isLoading: workOrderIsLoading } =
    useGetLastWorkOrderIdQuery();

  const {
    data: customerData,
    isLoading: customerIsLoading,
    isError: cutomerError,
    refetch: cutomerRefetch,
  } = useGetCustomerQuery({
    searchText: currentSearchQueryCustomer,
    id: "",
  });

  const {
    data: productData,
    isLoading: productIsLoading,
    refetch: productRefetch,
  } = useGetProductQuery({
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: currentSearchQueryProduct,
    createdDate: null,
    id: null,
  });

  const initialParams: IPriceHistoryPayload = {
    productName: "",
    transferTypeFrom: "",
    transferTypeTo: "",
  };

  const {
    data: priceHistoryData,
    isLoading: priceHistoryIsLoading,
    isError: priceHistoryError,
    refetch: priceHistoryRefetch,
  } = useGetPriceHistoryQuery(
    currentPriceQueryParams ? currentPriceQueryParams : initialParams,
    {
      skip: false,
    }
  );

  // const {
  //   data: updateData,
  //   isLoading: updateIsLoading,
  //   isError: updateError,
  // } = useUpdateInvoiceStatusQuery(
  //   {
  //     mainStatus: "2",
  //     id: id, // Use the ID for updating the invoice status
  //   },
  //   { skip: !id }
  // ); // Skip query until ID is available


    const {
      data: updateData,
      isLoading: updateIsLoading,
      isError: updateError,
  } = useUpdateInvoiceStatusQuery({
      mainStatus: "2",
      id: id, 
      po_number: poNumber || "", // ✅ Ensure po_number is always provided
  }, { skip: !id });

  const companyList: ICompanyDetails[] = Array.isArray(companyData?.data)
    ? (companyData?.data as ICompanyDetails[])
    : [];

  const rawData = workOrderLastData?.data;
  const workOrderId =
    typeof rawData === "number"
      ? rawData
      : parseInt(rawData as string, 10) || 0;

  useEffect(() => {
    if (
      priceHistoryData &&
      Array.isArray(priceHistoryData.data) &&
      priceHistoryData.data.length > 0
    ) {
      setAveragePrice(priceHistoryData.data[0]?.averagePrice || null);
      setNextPrice(priceHistoryData.data[0]?.price || null);
      setQuoteWorkOrderNo(priceHistoryData.data[0]?.quoteWorkOrderNo || null);
      setUpdated_at(priceHistoryData.data[0]?.updated_at || null);
      setPriceId(priceHistoryData.data[0]?.workOrderId || null);
      setBusCount(priceHistoryData.data[0]?.busCount || null);
    } else {
      setAveragePrice(null);
      setNextPrice(null);
      setQuoteWorkOrderNo(null);
      setUpdated_at(null);
      setPriceId(null);
      setBusCount(null); 
    }
  }, [priceHistoryData]);

  const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);

  // useEffect(() => {
  //   if (debouncedSearchQuery.length >= 0 || debouncedSearchQuery === "") {
  //     setCurrentSearchQuery(debouncedSearchQuery);
  //     refetch();
  //   }
  // }, [debouncedSearchQuery, refetch]);

  // const handleFocusOrClick = () => {
  //   setShowDropdown(true);
  //   if (currentSearchQuery === "") {
  //     refetch();
  //   }
  // };

  const handleFocusOrClickCustomer = () => {
    setShowDropdownCustomer(true);
    if (currentSearchQueryCustomer === "") {
      refetch();
    }
  };

  //  useEffect(() => {
  //       // Fetch all cities in Canada (country code "CA")
  //       const cities = City.getCitiesOfCountry("CA");
  //       if (cities) {
  //         setCanadianCities(cities.map((city) => city.name));
  //       }
  //     }, []);

       useEffect(() => {
            // Merge library cities with comprehensive hardcoded list, deduplicate, sort
            const libCities = City.getCitiesOfCountry("CA")?.map(c => c.name) || [];
            const merged = Array.from(new Set([...libCities, ...CANADIAN_CITIES])).sort();
            setCanadianCities(merged);
          }, []);
  

  useEffect(() => {
    if (
      debouncedSearchQueryCustomer && debouncedSearchQueryCustomer.length >= 2 ||
      debouncedSearchQueryCustomer === ""
    ) {
      setCurrentSearchQueryCustomer(debouncedSearchQueryCustomer);
      cutomerRefetch();
    }
  }, [debouncedSearchQueryCustomer, cutomerRefetch]);

  useEffect(() => {
    if (
      debouncedSearchQueryProduct.length >= 2 ||
      debouncedSearchQueryProduct === ""
    ) {
      setCurrentSearchQueryProduct(debouncedSearchQueryProduct);
      productRefetch();
    }
  }, [debouncedSearchQueryProduct, productRefetch]);

  // useEffect(() => {
  //   const totalSubTotal = productRows.reduce((acc, row) => acc + row.total, 0);
  //   setSubTotal(totalSubTotal);

  //   const calculatedTotalDiscount = discounts.reduce(
  //     (acc, discount) => acc + (discount.value),
  //     0
  //   );
  //   setTotalDiscount(calculatedTotalDiscount);

  //   const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
  //   setGrandTotal(totalGrandTotal);
  // }, [productRows, discounts]);

  useEffect(() => {
     if (productRows.length > 0) {
       const totalSubTotal = productRows.reduce(
         (acc, row) => acc + row.total,
         0
       );
       setSubTotal(totalSubTotal);
 
       const calculatedTotalDiscount = discounts.reduce(
         (acc, discount) => acc + (discount.value ?? 0),
         0
       );
       setTotalDiscount(calculatedTotalDiscount);
 
       if (totalSubTotal > 0) {
         const unitPriceDiscount = totalDiscount / totalSubTotal;
         setUnitPrice(unitPriceDiscount);
 
         const updatedRows = productRows.map((row) => {
           const price = row.price ?? 0;
           const quantity = row.quantity ?? 0;
           const tax = row.tax ?? 0;
 
           const priceWithDiscount = price * (1 - unitPriceDiscount);
           const unitProductPriceWithDiscountAndTax =
             priceWithDiscount * (1 + tax / 100);
           const totalWithDiscountAndTax =
             priceWithDiscount * quantity * (1 + tax / 100);
             const taxAmountWithDiscount = priceWithDiscount * (tax / 100);
 
           return {
             ...row,
             unitPriceWithDiscount: unitProductPriceWithDiscountAndTax,
             unitTotalWithDiscount: totalWithDiscountAndTax,
             taxAmount: taxAmountWithDiscount, // Updating taxAmount after discount
           };
         });
 
         setProductRows((prevRows) => {
           // Only update the state if rows have actually changed
           if (JSON.stringify(prevRows) !== JSON.stringify(updatedRows)) {
             return updatedRows;
           }
           return prevRows;
         });
 
         const totalSubTotalWithDiscount = updatedRows.reduce(
           (acc, row) => acc + row.unitTotalWithDiscount,
           0
         );
         setGrandTotalWithDiscount(totalSubTotalWithDiscount);
       }
     }
   }, [productRows, discounts, totalDiscount]);
  
  const productList: IProductPopUP[] = Array.isArray(productData?.data)
    ? (productData?.data as IProductPopUP[])
    : [];

  const customerList: ICustomer[] = Array.isArray(customerData?.data)
    ? (customerData?.data as ICustomer[])
    : [];

  const today = dayjs();

  const handleProductSelect = (product: IProductPopUP, index: number) => {
    const updatedRows = [...productRows];
    updatedRows[index].productName = product.productName;
    updatedRows[index].productImg = product.productImg || "";

    setProductRows(updatedRows);
    setShowDropdownProductIndex(null);
    updatePriceQueryParams(updatedRows[index]);
  };

  const handleAddRow = () => {
    setEditIndex(null);
    setPopupOpen(true);
    
    setProductRows((prev) => [
      ...prev,
      {
        productName: "",
        productDescription: "",
        productImg: "",
        numberOfPassengers: null,
        busCount: null,
        transferType: TransferType.OneWayTransfer,
        transferTypeFrom: "",
        transferTypeTo: "",
        transferTypeDescription: "",
        departureDateTime: null,
        returnDateTime: null,
        departureAddress: "",
        destinationAddress: "",
        multiDestination: "",
        quantity: 1,
        price: null,
        tax: 0,
        taxAmount: 0,
        total: 0,
        taxId: 1,
        unitPriceWithDiscount: null,
        unitTotalWithDiscount: 0,
        productType: ProductType.Bus,
        productLongDescription: "",
        productShortDescription: "",
        pickups: [ { address: "", city: "", dateTime: null } ],   // first pickup
        dropoffs: [ { address: "", city: "", dateTime: null } ],  // first dropoff
        returnPickups: [{ address: "", city: "", dateTime: null }],
        returnDropoffs: [{ address: "", city: "", dateTime: null }],
      },
    ]);
    setSearchQueryProduct("");
  };

  const handlePriceChange = (index: number, newPrice: number) => {
    const updatedRows = [...productRows];
    const product = updatedRows[index];
    product.price = newPrice;
  
    // Recalculate the tax amount whenever the price changes
    const newTaxAmount = newPrice * (product.tax / 100);
    product.taxAmount = newTaxAmount;

    const newTotal = newPrice * (product.quantity || 1) + newTaxAmount;
    product.total = newTotal;

    product.unitTotalWithDiscount = newTotal;
  
    setProductRows(updatedRows);
   // console.log(updatedRows)
  };


  const updateTransferTypes = (updated: typeof productRows, productIndex: number) => {
    const product = updated[productIndex];
  
    if (!product.transferTypeFrom) {
      product.transferTypeFrom = product.pickups?.[0]?.city || "";
    }
  
    if (!product.transferTypeTo) {
      product.transferTypeTo = product.dropoffs?.[0]?.city || "";
    }
  };
  
  // Handle changes to items in pickups/dropoffs arrays
  const handleFieldChangeArray = (
    productIndex: number,
    field: "pickups" | "dropoffs" | "returnPickups" | "returnDropoffs",
    itemIndex: number,
    key: "address" | "city" | "dateTime",
    value: any
  ) => {
    const updated = [...productRows];
    if (!updated[productIndex][field]) updated[productIndex][field] = [];
  
    updated[productIndex][field]![itemIndex][key] = value;
     const product = updated[productIndex];
  
    // Update transferTypeFrom/To only if field is pickups or dropoffs
    if (field === "pickups" || field === "dropoffs") {
      updateTransferTypes(updated, productIndex);
    }
  
   if (product.transferType !== TransferType.OneWayTransfer) {
      if (field === "pickups" && (!product.returnPickups || product.returnPickups.length === 0)) {
        product.returnPickups = (product.pickups || []).map(p => ({ ...p }));
      }
      if (field === "dropoffs" && (!product.returnDropoffs || product.returnDropoffs.length === 0)) {
        product.returnDropoffs = (product.dropoffs || []).map(d => ({ ...d }));
      }
    }
    
  
    setProductRows(updated);
  };
  
  // Add a new item to pickups/dropoffs arrays
  const addArrayItem = (
    productIndex: number,
    field: "pickups" | "dropoffs" | "returnPickups" | "returnDropoffs"
  ) => {
    const updated = [...productRows];
    if (!updated[productIndex][field]) updated[productIndex][field] = [];
  
    updated[productIndex][field]!.push({ address: "", city: "", dateTime: null });
  
    if (field === "pickups" || field === "dropoffs") {
      updateTransferTypes(updated, productIndex);
    }
  
    setProductRows(updated);
  };
  
  // Remove an item from pickups/dropoffs arrays
  const removeArrayItem = (
    productIndex: number,
    field: "pickups" | "dropoffs" | "returnPickups" | "returnDropoffs",
    itemIndex: number
  ) => {
    const updated = [...productRows];
    updated[productIndex][field]?.splice(itemIndex, 1);
  
    if (field === "pickups" || field === "dropoffs") {
      updateTransferTypes(updated, productIndex);
    }
  
    setProductRows(updated);
  };


 const handleSaveProduct = () => {
    const currentRow = productRows[editIndex !== null ? editIndex : productRows.length - 1];
    let newErrors: { departureDateTime?: string; returnDateTime?: string } = {};
  
    // Validate Departure Date & Time (Required)
    // if (!currentRow?.departureDateTime) {
    //   newErrors.departureDateTime = "Departure Date & Time is required";
    // }
  
    // // Validate Return Date & Time if Transfer Type is NOT One-Way
    // if (currentRow?.transferType !== TransferType.OneWayTransfer && !currentRow?.returnDateTime) {
    //   newErrors.returnDateTime = "Return Date & Time is required";
    // }
  
    // If there are errors, update the state and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
  
    // Clear errors if all validations pass
    setErrors({});
  
    if (editIndex !== null) {
      // Edit existing row
      const updatedRows = [...productRows];
      updatedRows[editIndex] = currentRow;
      setProductRows(updatedRows);
    } else {
      // Add new product
      setProductRows([...productRows]);
    }
  
    setPopupOpen(false);
  };

  const handleCancel = () => {
    if (editIndex !== null && originalProduct) {
      // Log the original product row before canceling
      console.log("Reverting to the original product row:", originalProduct);
  
      // Revert to the original product data (before editing)
      setProductRows(prevRows => {
        const updatedRows = [...prevRows];
        updatedRows[editIndex] = originalProduct; // Restore the original row
        return updatedRows;
      });
  
    
      setEditIndex(null);    // Clear edit index
      setOriginalProduct(null);  // Clear original product data after canceling
    } else {
      // If no row is being edited, just close the popup and remove the last empty row if necessary
      const lastRow = productRows[productRows.length - 1];
      if (
        !lastRow?.productName ||
        !lastRow?.productDescription ||
        !lastRow?.price ||
        (lastRow?.tax && lastRow?.tax <= 0)
      ) {
        console.log("Removing last row because it's empty or invalid");
        setProductRows(productRows.slice(0, productRows.length - 1));
      }
    }
    setPopupOpen(false);  // Close the popup
  };
  
  // const handleFieldChange = <K extends keyof IProduct>(
  //   index: number,
  //   field: K,
  //   value: IProduct[K]
  // ) => {
  //   const updatedRows = [...productRows];
  //   updatedRows[index][field] = value;

  //   updatedRows[index].total =
  //     updatedRows[index].price *
  //     updatedRows[index].quantity *
  //     (1 + updatedRows[index].tax / 100);

  //   setProductRows(updatedRows);
  // };

  // const handleFieldChange = <K extends keyof IProduct>(
  //   index: number,
  //   field: K,
  //   value: IProduct[K]
  // ) => {
  //   const updatedRows = [...productRows];
  //   updatedRows[index][field] = value;

  //   const price = updatedRows[index].price ?? 0;
  //   const quantity = updatedRows[index].quantity ?? 0;
  //   const tax = updatedRows[index].tax ?? 0;

  //   updatedRows[index].total = price * quantity * (1 + tax / 100);

  //   setProductRows(updatedRows);
  // };

  const handleFieldChange = <K extends keyof IProduct>(
    index: number,
    field: K,
    value: IProduct[K]
  ) => {
    const updatedRows = [...productRows];
    updatedRows[index][field] = value;

    const price = updatedRows[index].price ?? 0;
    const quantity = updatedRows[index].quantity ?? 0;
    const tax = updatedRows[index].tax ?? 0;

    updatedRows[index].total = price * quantity;

    const totalSubTotal = updatedRows.reduce((acc, row) => acc + row.total, 0);

    const totalDiscountValue = discounts.reduce(
      (acc, discount) => acc + (discount.value ?? 0),
      0
    );

    const unitPriceDiscount = totalDiscountValue / totalSubTotal;

    const priceWithDiscount = price * (1 - unitPriceDiscount);

    const unitProductPriceWithDiscountAndTax =
      priceWithDiscount * (1 + tax / 100);

    const totalWithDiscountAndTax =
      priceWithDiscount * quantity * (1 + tax / 100);

    updatedRows[index].unitPriceWithDiscount =
      unitProductPriceWithDiscountAndTax;
    updatedRows[index].unitTotalWithDiscount = totalWithDiscountAndTax;

    setProductRows(updatedRows);

    if (
      updatedRows[index].productName &&
      updatedRows[index].transferTypeFrom &&
      updatedRows[index].transferTypeTo
    ) {
      updatePriceQueryParams(updatedRows[index]);
      setCurrentIndex(index);
    }
  };
  


  const updatePriceQueryParams = (row: IProduct) => {
    const { productName, transferTypeFrom, transferTypeTo } = row;

    if (productName && transferTypeFrom && transferTypeTo) {
      const newParams: IPriceHistoryPayload = {
        productName,
        transferTypeFrom,
        transferTypeTo,
      };

      setCurrentPriceQueryParams(newParams);

      if (newParams) {
        priceHistoryRefetch();
      }
    } else {
      console.error("Incomplete parameters for price query.");
    }
  };

  useEffect(() => {
  // Calculate total subtotal
  const totalSubTotal = productRows.reduce((acc, row) => acc + (row.total || 0), 0);
  setSubTotal(totalSubTotal);

  // Calculate total discount
  const calculatedTotalDiscount = discounts.reduce(
    (acc, discount) => acc + (discount.value ?? 0),
    0
  );
  setTotalDiscount(calculatedTotalDiscount);

  // Calculate grand total (subtotal - discount)
  const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
  setGrandTotal(totalGrandTotal);

  // Calculate unit price
  const unitPrice = totalSubTotal > 0 ? calculatedTotalDiscount / totalSubTotal : 0;
  setUnitPrice(unitPrice);


 const calculatedHst = productRows.reduce((acc, row) => {
   return acc + (row.taxAmount ?? 0);
}, 0);
    setTaxAmount(calculatedHst);

  // Calculate grand total with discounts
  const totalSubTotalWithDiscount = productRows.reduce(
    (acc, row) => acc + (row.unitTotalWithDiscount || 0),
    0
  );
  setGrandTotalWithDiscount(totalSubTotalWithDiscount);
}, [productRows, discounts]);



  const handleProductNameChange = (index: number, value: string) => {
    setSearchQueryProduct(value);
    handleFieldChange(index, "productName", value);
  };

  const handleDeleteRow = (index: number) => {
   // const updatedRows = productRows.filter((_, i) => i !== index);
    const updatedRows = [...productRows];
    updatedRows.splice(index, 1);
    setProductRows(updatedRows);
   // console.log(updatedRows)
  };

  const handleEditRow = (index: number) => {
    const productToEdit = productRows[index];
    setOriginalProduct({ ...productToEdit });
    setEditIndex(index);
    setPopupOpen(true);
    //console.log("Editing product: ", productToEdit);

  };


  // Assuming you're using setProductRows to update the rows



  const handleDiscountChange = (
    index: number,
    field: keyof IDiscount,
    value: any
  ) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts[index] = {
      ...updatedDiscounts[index],
      [field]: value,
    };
    setDiscounts(updatedDiscounts);
  };

  const handleOpenDialog = (index: number | null) => {
    if (index !== null) {
      // Editing existing discount
      const discountToEdit = discounts[index];
      setDiscountValue(discountToEdit.value ?? 0);
      setDiscountDescription(discountToEdit.description);
      setEditingIndex(index); // Set the index of the item being edited
    } else {
      // Adding a new discount
      setDiscountValue(0);
      setDiscountDescription("");
      setEditingIndex(null); // Reset editing index
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDiscountValue(0);
    setDiscountDescription("");
    setEditingIndex(null);
  };
  const handleSaveDiscount = () => {
    if (editingIndex !== null) {
      // Update existing discount
      const updatedDiscounts = discounts.map((discount, index) =>
        index === editingIndex
          ? { value: discountValue, description: discountDescription }
          : discount
      );
      setDiscounts(updatedDiscounts);
    } else {
      // Add a new discount
      setDiscounts((prev) => [
        ...prev,
        { value: discountValue, description: discountDescription },
      ]);
    }
    handleCloseDialog();
  };


  const handleDeleteDiscount = (index: number) => {
    const updatedDiscounts = discounts.filter((_, i) => i !== index);
    setDiscounts(updatedDiscounts);
  };

  const formik = useFormik({
    initialValues: {
      companyName: "",
      companyLogo: "",
      companyProvince: "",
      companyCity: "",
      companyPostalCode: "",
      companyStreetNumber: "",
      companyStreetName: "",
      companyMobileNumber: "",
      companyEmail: "",
      companyAddress: "",
      quoteWorkOrderNo: "",
      quoteWorkOrderIssueDate: null,
      quoteWorkOrderDueDate: null,
      quoteWorkOrderStatus: "",
      quoteTripId: "",
      quoteTripName: "",
      customerCompanyName: "",
      customerFirstName: "",
      customerLastName: "",
      customerMobileNum: "",
      customerEmail: "",
      customerProvince: "",
      customerCity: "",
      customerPostalCode: "",
      customerStreetNumber: "",
      customerStreetName: "",
      quoteWorkOrderSale: [],
      quoteWorkOrderSaleDiscount: "",
      quoteWorkOrderSaleSubTotal: "",
      quoteWorkOrderSaleGrandTotal: "",
      quoteWorkOrderSaleDiscountDescription: [],
      quoteWorkOrderCompanyId: "",
      quoteWorkOrderCustomerId: customerId,
      quoteWorkOrderCustomerRemark: "",
      quoteWorkOrderCustomerMemo: "",
    },

    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};
 if (!values.companyName) errors.companyName = "Company name is required";

      // const mobileNumberError = validatePhoneNumber(values.companyMobileNumber);
      // if (mobileNumberError) {
      //   errors.companyMobileNumber = mobileNumberError;
      // }

      // const emailError = validateEmail(values.companyEmail);
      // if (emailError) {
      //   errors.companyEmail = emailError;
      // }

      // const customerMobileNumberError = validatePhoneNumber(
      //   values.customerMobileNum
      // );
      // if (customerMobileNumberError) {
      //   errors.customerMobileNum = customerMobileNumberError;
      // }

      const customerEmailError = validateEmail(values.customerEmail);
      if (customerEmailError) {
        errors.customerEmail = customerEmailError;
      }

      return errors;
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          companyName: values.companyName,
          companyLogo: values.companyLogo,
          companyProvince: values.companyProvince,
          companyCity: values.companyCity,
          companyPostalCode: values.companyPostalCode,
          companyStreetNumber: values.companyStreetNumber,
          companyStreetName: values.companyStreetName,
          companyMobileNumber: values.companyMobileNumber,
          companyEmail: values.companyEmail,
          companyAddress: values.companyAddress,
          quoteWorkOrderNo: generatedWorkOrderNo,
          quoteTripId: values.quoteTripId,
          quoteTripName:  values.quoteTripName,
          quoteWorkOrderIssueDate: values.quoteWorkOrderIssueDate,
          quoteWorkOrderDueDate: values.quoteWorkOrderDueDate,
          quoteWorkOrderStatus: String(values.quoteWorkOrderStatus),
          customerCompanyName: values.customerCompanyName,
           customerFirstName: values.customerFirstName,
          customerLastName: values.customerLastName,
          customerMobileNum: values.customerMobileNum,
          customerEmail: values.customerEmail,

          customerProvince: values.customerProvince,
          customerCity: values.customerCity,
          customerPostalCode: values.customerPostalCode,
          customerStreetNumber: values.customerStreetNumber,
          customerStreetName: values.customerStreetName,

       
          quoteWorkOrderSale: productRows,
          quoteWorkOrderDiscount: String(totalDiscount),
          quoteWorkOrderSubTotal: String(subTotal),
          quoteWorkOrderSaleGrandTotal: String(grandTotalEithDiscount),
          quoteWorkOrderSaleDiscountDescription: discounts,
          quoteWorkOrderCompanyId: String(values.quoteWorkOrderCompanyId),
          quoteWorkOrderCustomerId: String(values.quoteWorkOrderCustomerId),
          quoteWorkOrderCustomerRemark: values.quoteWorkOrderCustomerRemark,
          quoteWorkOrderCustomerMemo: values.quoteWorkOrderCustomerMemo,
        };


        const addCompanyResponse = await newTax(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
         
        } else {
          showMessage(addCompanyResponse.message);
          setId(addCompanyResponse.data?.id);
          setOpenD(true);
          cancelFunction();
          // loadingFunction();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (workOrderId !== null) {
      const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);
      formik.setFieldValue("quoteWorkOrderNo", generatedWorkOrderNo);
      formik.setFieldValue("quoteWorkOrderStatus", WorkOrderStatus?.Initiated);
      formik.setFieldValue("quoteTripId", workOrderId);
    }
  }, [workOrderId]);

  const formatAddress = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };

  const customerFormatAddress = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    if (!streetNumber && !streetName && !city && !province && !postalCode) {
      return ""; // Return an empty string if all fields are empty
    }

    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };

  const handleSelect = (companyId: string) => {
    const selectedCompany = companyList.find(
      (company) => String(company.id) === companyId
    );
    if (selectedCompany) {
      // setSearchQuery(selectedCompany.companyName);

      const formattedAddress = formatAddress(
        selectedCompany.companyStreetNumber,
        selectedCompany.companyStreetName,
        selectedCompany.companyCity,
        selectedCompany.companyProvince,
        selectedCompany.companyPostalCode,
      );

      formik.setFieldValue("companyName", selectedCompany.companyName);
      formik.setFieldValue(
        "companyStreetNumber",
        selectedCompany.companyStreetNumber
      );
      formik.setFieldValue(
        "companyStreetName",
        selectedCompany.companyStreetName
      );
      formik.setFieldValue("companyProvince", selectedCompany.companyProvince);
      formik.setFieldValue("companyCity", selectedCompany.companyCity);
      formik.setFieldValue(
        "companyPostalCode",
        selectedCompany.companyPostalCode
      );
     

      formik.setFieldValue(
        "companyMobileNumber",
        selectedCompany.companyMobileNumber
      );

      formik.setFieldValue("companyEmail", selectedCompany.companyEmail);
      formik.setFieldValue("quoteWorkOrderCompanyId", selectedCompany.id);

      formik.setFieldValue("companyAddress", formattedAddress);
      setSelectedCompanyLogo(selectedCompany.CompanyLogo);
    }
  };

  // const defaultCompany = companyList.find(
  //   (company) => company.isDefault === 1
  // );

  // const selectedCompanyConst = defaultCompany || companyList[0];

  useEffect(() => {
    if (companyList && companyList.length > 0) {
      const defaultCompany = companyList.find(
        (company) => company.isDefault === 1
      );

      const selectedCompany = defaultCompany || companyList[0];

      if (selectedCompany) {
        setSelectedDefultCompanyId(String(selectedCompany.id));

        const formattedAddress = customerFormatAddress(
          selectedCompany.companyStreetNumber,
          selectedCompany.companyStreetName,
          selectedCompany.companyCity,
          selectedCompany.companyProvince,
          selectedCompany.companyPostalCode,
        );

        formik.setFieldValue("companyName", selectedCompany.companyName);
        formik.setFieldValue(
          "companyStreetNumber",
          selectedCompany.companyStreetNumber
        );
        formik.setFieldValue(
          "companyStreetName",
          selectedCompany.companyStreetName
        );
        formik.setFieldValue("companyCity", selectedCompany.companyCity);
        formik.setFieldValue(
          "companyProvince",
          selectedCompany.companyProvince
        );
       
        formik.setFieldValue(
          "companyPostalCode",
          selectedCompany.companyPostalCode
        );
        formik.setFieldValue(
          "companyMobileNumber",
          selectedCompany.companyMobileNumber
        );
       
       
        formik.setFieldValue("companyEmail", selectedCompany.companyEmail);
        formik.setFieldValue("quoteWorkOrderCompanyId", selectedCompany.id);
        formik.setFieldValue("companyAddress", formattedAddress);
        setSelectedCompanyLogo(selectedCompany.CompanyLogo);
      }
    }
  }, [companyList]);

  useEffect(() => {
    if (customerId && customerList.length > 0) {
      handleSelectCustomer(customerId);
    }
  }, [customerId, customerList]);

  const handleSelectCustomer = (customerId: string) => {
    const selectedCustomer = customerList.find(
      (customer) => String(customer.id) === customerId
    );
    if (selectedCustomer) {

      const customerFormattedAddress = customerFormatAddress(
        selectedCustomer.customerStreetNumber,
        selectedCustomer.customerStreetName,
        selectedCustomer.customerCity,
        selectedCustomer.customerProvince,
        selectedCustomer.customerPostalCode,
      );


      setSearchQueryCustomer(
        // (selectedCustomer.customerFirstName || " ") +
        //   " " +
        //   (selectedCustomer.customerLastName || " ")
      //  selectedCustomer.customerCompanyName
        selectedCustomer.customerCompanyName?.trim()
    ? selectedCustomer.customerCompanyName
    : `${selectedCustomer.customerFirstName || ""} ${selectedCustomer.customerLastName || ""}`
      );

      formik.setFieldValue( "customerCompanyName",
        selectedCustomer.customerCompanyName
      );
      formik.setFieldValue(
        "customerFirstName",
        selectedCustomer.customerFirstName || ""
      );
      formik.setFieldValue(
        "customerLastName",
        selectedCustomer.customerLastName
      );
      formik.setFieldValue(
        "customerMobileNum",
        selectedCustomer.customerMobileNum
      );
      formik.setFieldValue("customerEmail", selectedCustomer.customerEmail);
      formik.setFieldValue("customerAddress", customerFormattedAddress);
      formik.setFieldValue("quoteWorkOrderCustomerId", selectedCustomer.id);
    }
    setShowDropdownCustomer(false);
  };

  const cancelFunction = () => {
    formik.resetForm();
    // setSearchQuery("");
    // setCurrentSearchQuery("");
    setSearchQueryCustomer("");
    setCurrentSearchQueryCustomer("");
    setSearchQueryProduct("");
    setCurrentSearchQueryProduct("");
    setShowDropdownProductIndex(null);
    // setDiscount(0);
    setDiscountDescription("");
    setSubTotal(0);
    setGrandTotal(0);
    setSelectedCompanyLogo(null);
    // handleSelect(String(selectedCompanyConst));
    setProductRows([
      {
        productName: "",
        productDescription: "",
        productImg: "",
        numberOfPassengers: null || 0,
        busCount: null || 0,
        transferType: TransferType.OneWayTransfer,
        transferTypeFrom: "",
        transferTypeTo: "",
        transferTypeDescription: "",
        departureDateTime: null,
        returnDateTime: null,
        departureAddress: "",
        destinationAddress: "",
        multiDestination: "",
        quantity: 1,
        price: null || 0,
        tax: null || 0,
        taxAmount: null || 0,
        total: 0,
        taxId: null,
        unitPriceWithDiscount: null,
        unitTotalWithDiscount: 0,
        productType: ProductType.Bus,
        productLongDescription: "",
        productShortDescription: "",
      },
    ]);
    setDiscounts([{ value: null || 0, description: "" }]);
    setTotalDiscount(0);
   // navigate(-1);
  };

  const formValid = useMemo(() => {
    return formik.values.companyName === "" ||
      formik.values.companyName === undefined ||
      formik.values.customerMobileNum === "" ||
      formik.values.customerMobileNum === undefined ||
      formik.values.customerCompanyName === "" ||
      formik.values.customerCompanyName === undefined ||
      formik.values.quoteWorkOrderStatus === "" ||
      formik.values.quoteWorkOrderStatus === undefined
      ? false
      : true;
  }, [formik]);

  useEffect(() => {
      const now = dayjs().tz("America/Toronto");
    if (formik.values.quoteWorkOrderIssueDate === null) {
      formik.setFieldValue("quoteWorkOrderIssueDate", now);
    }
    if (formik.values.quoteWorkOrderDueDate === null) {
          formik.setFieldValue("quoteWorkOrderDueDate",  now.add(5, "day"));
        }
  }, [formik.values.quoteWorkOrderIssueDate, formik.values.quoteWorkOrderDueDate]);

  // useEffect(() => {
  //   if (formik.values.quoteWorkOrderStatus === "") {
  //     if (companyList && companyList.length > 0) {
  //       setSelectedCompanyId(String(companyList[0].id));
  //     }
  //     formik.setFieldValue("quoteWorkOrderStatus", selectedCompanyId);
  //   }
  // }, [formik.values.quoteWorkOrderStatus, companyList]);

  // const loadingFunction = () => {
  //   if (
  //     isLoading ||
  //     taxLoading ||
  //     workOrderIsLoading ||
  //     productIsLoading ||
  //     companyIsLoading ||
  //     customerIsLoading ||
  //     priceHistoryIsLoading
  //   ) {
  //     return (
  //       <Box
  //         display="flex"
  //         justifyContent="center"
  //         alignItems="center"
  //         height="10vh"
  //       >
  //         <CircularProgress />
  //       </Box>
  //     );
  //   }
  // };

  const handleConfirmDialog = async () => {
   // setPoNumber(poNumber.trim() ? poNumber : ""); 
    setOpen(false);
   
    if (updateIsLoading) return;

    try {
      if (updateData && !updateError) {
        showMessage("Converted to invoice successfully");
        navigate(-1);
      } else if (updateError) {
        showErrorMessage("Failed to convert to invoice");
      }
    } catch (error) {
      showErrorMessage("Error occurred while converting to invoice");
    }
  };

  return (
    <div>
      <Card className={classes.quotesCard}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} padding={2}>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={5}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={3} md={3} sm={4} xs={4}>

                      
                      {selectedCompanyLogo ? (
                        
                        <img
                          src={`${LARAVEL_API_URL}/${selectedCompanyLogo}`}
                          alt="Company Logo"
                          className={classes.quoteImg}
                   
                        />
                      ) : (
                        <img alt="Company Logo" className={classes.quoteImg} />
                      )}
                    </Grid>
                    <Grid
                      item
                      lg={9}
                      md={9}
                      sm={8}
                      xs={8}
                      display="flex"
                      sx={{
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                        textAlign: "end",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <Button
                            variant="contained"
                            className={classes.editButtonList}
                            onClick={() => {
                              setOpenCompany(true);
                            }}
                          >
                            <AddIcon className={classes.editListIcon} />
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            startIcon={<ArrowBackIosIcon />}
                            className={classes.addButton}
                            onClick={() => navigate(-1)}
                          >
                            Back
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Quote Number :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Quote Number :"
                            size="small"
                            {...formik.getFieldProps("quoteWorkOrderNo")}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Status :</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            select
                            size="small"
                            className={classes.textField}
                            SelectProps={{
                              native: false,
                            }}
                            defaultValue="Pending"
                            InputLabelProps={{ shrink: true }}
                            {...formik.getFieldProps("quoteWorkOrderStatus")}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(WorkOrderStatus).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {key}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid> */}

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            PO Number :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter PO Number"
                            size="small"
                            className={classes.textField}
                            value={poNumber}
                            onChange={(e) => setPoNumber(e.target.value)}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>


                       <Grid item lg={10} md={12} sm={12} xs={12}>
                                          <Grid container alignItems="center">
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                              <Typography variant="subtitle1">
                                               Trip Id :
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                              <TextField
                                                placeholder="Enter Trip Id"
                                                size="small"
                                                {...formik.getFieldProps("quoteTripId")}
                                                className={classes.textField}
                                                InputProps={{
                                                  readOnly: true,
                                                  sx: {
                                                    fontSize: 14,
                                                  },
                                                }}
                                                InputLabelProps={{
                                                  sx: {
                                                    fontSize: 14,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>

                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid
                    container
                    spacing={3}
                    display={"flex"}
                    justifyContent={"flex-end"}
                  >
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Invoice Date :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={formik.values.quoteWorkOrderIssueDate}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "quoteWorkOrderIssueDate",
                                  date
                                )
                              }
                              //defaultValue={today}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  sx: { width: "100%" },
                                  InputProps: {
                                    sx: { fontSize: 14 },
                                  },
                                  InputLabelProps: {
                                    sx: { fontSize: 14 },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Due Date :
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={formik.values.quoteWorkOrderDueDate}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "quoteWorkOrderDueDate",
                                  date
                                
                                )
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  sx: { width: "100%" },
                                  InputProps: {
                                    sx: { fontSize: 14 },
                                  },
                                  InputLabelProps: {
                                    sx: { fontSize: 14 },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid> */}



 <Grid item lg={10} md={12} sm={12} xs={12}>
                                       <Grid container alignItems="center">
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <Typography variant="subtitle1">
                                            Trip Name :
                                           </Typography>
                                         </Grid>
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <TextField
                                             placeholder="Enter Trip Name :"
                                             size="small"
                                             {...formik.getFieldProps("quoteTripName")}
                                             className={classes.textField}
                                             InputProps={{
                                              
                                               sx: {
                                                 fontSize: 14,
                                               },
                                             }}
                                             InputLabelProps={{
                                               sx: {
                                                 fontSize: 14,
                                               },
                                             }}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid> 

                  </Grid>
                </Grid>

              
               
                  



              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={5}>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item>
                          <Typography className={classes.h4Quoto}>
                            Issue From :
                          </Typography>
                        </Grid>
                        {/* <Grid item>
                          <TextField
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CiSearch
                                    className={classes.searchWidgetIcon}
                                  />
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.formControlListQuto,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setShowDropdown(true);
                            }}
                            placeholder="Company Name .."
                            size="small"
                            defaultValue={""}
                            onFocus={handleFocusOrClick}
                            onClick={handleFocusOrClick}
                            sx={{ flexGrow: 1, width: "100%" }}
                            InputLabelProps={{ shrink: true }}
                          />

                          {showDropdown && (
                            <Paper className={classes.dropdownPaper}>
                              {companyIsLoading ? (
                                <div
                                  style={{
                                    textAlign: "center",
                                    padding: "10px",
                                  }}
                                >
                                  <CircularProgress size={24} />
                                </div>
                              ) : (
                                companyList.length > 0 &&
                                companyList.map((company) => (
                                  <MenuItem
                                    key={company.id}
                                    onClick={() =>
                                      handleSelect(String(company.id))
                                    }
                                  >
                                    {company.companyName}
                                  </MenuItem>
                                ))
                              )}
                            </Paper>
                          )}
                        </Grid> */}
                        <Grid item>
                          <TextField
                            select
                            size="small"
                            InputProps={{
                              classes: {
                                root: classes.formControlListQutoWithoutSearch,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            className={classes.textField}
                            value={selectedDefultCompanyId}
                            onChange={(event) => {
                              const selectedId = event.target.value;
                              setSelectedDefultCompanyId(selectedId);
                              handleSelect(selectedId);
                            }}
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem
                              value=""
                              disabled
                              style={{ color: "gray" }}
                            >
                              Select an option
                            </MenuItem>
                            {companyList &&
                              companyList.map((company) => (
                                <MenuItem
                                  key={company.id}
                                  value={String(company.id)}
                                >
                                  {company.companyName}
                                </MenuItem>
                              ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Company Name"
                        size="small"
                        {...formik.getFieldProps("companyName")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Company Address"
                        size="small"
                        value={formik.values.companyAddress}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        multiline
                        rows={5}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Phone Number"
                        size="small"
                        {...formik.getFieldProps("companyMobileNumber")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.companyMobileNumber &&
                          Boolean(formik.errors.companyMobileNumber)
                        }
                        helperText={
                          formik.touched.companyMobileNumber &&
                          formik.errors.companyMobileNumber
                        }
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Email"
                        size="small"
                        {...formik.getFieldProps("companyEmail")}
                        className={classes.textField}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.companyEmail &&
                          Boolean(formik.errors.companyEmail)
                        }
                        helperText={
                          formik.touched.companyEmail &&
                          formik.errors.companyEmail
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Grid
                    container
                    spacing={3}
                    display={"flex"}
                    justifyContent={"flex-end"}
                  >
                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        // alignItems="center"
                        alignItems={showDropdownCustomer ? "flex-start" : "center"} 
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item sx={{ marginTop: showDropdownCustomer ? "8px" : 0 }} >
                          <Typography className={classes.h4Quoto}>
                            Issue For:
                          </Typography>
                        </Grid>
                        <Grid item xs>
                          <TextField
                          disabled 
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CiSearch
                                    className={classes.searchWidgetIcon}
                                  />
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.formControlListQuto,
                                notchedOutline: classes.notchedOutline,
                              },
                              readOnly: true,
                            }}
                            value={searchQueryCustomer}
                            onChange={(e) => {
                              setSearchQueryCustomer(e.target.value);
                              setShowDropdownCustomer(true);
                            }}
                            placeholder="Name & phone number .."
                            size="small"
                            defaultValue={""}
                            onFocus={handleFocusOrClickCustomer}
                            onClick={handleFocusOrClickCustomer}
                            sx={{ flexGrow: 1, width: "100%" }}
                            InputLabelProps={{ shrink: true }}
                          />

                          {showDropdownCustomer && (
                            <Paper className={classes.dropdownPaper}>
                              {customerIsLoading ? (
                                <div
                                  style={{
                                    textAlign: "center",
                                    padding: "10px",
                                  }}
                                >
                                  <CircularProgress size={24} />
                                </div>
                              ) : (
                                customerList.length > 0 &&
                                customerList.map((company) => (
                                  <MenuItem
                                    key={company.id}
                                    onClick={() =>
                                      handleSelectCustomer(String(company.id))
                                    }
                                  >
                                    {/* {(company.customerFirstName || "") +
                                      " " +
                                      (company.customerLastName || "")} */}

                                   {`${company.customerFirstName || ""} ${company.customerLastName || ""}`}
                                    {company.customerCompanyName ? ` (${company.customerCompanyName})` : ""}

                                    
                                  </MenuItem>
                                ))
                              )}
                            </Paper>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Name"
                        size="small"
                        {...formik.getFieldProps("customerCompanyName")}
                           value={
    formik.values.customerCompanyName?.trim()
      ? formik.values.customerCompanyName
      : `${formik.values.customerFirstName || ""} ${formik.values.customerLastName || ""}`
  }
                        className={classes.textField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>

                    {/* <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Address"
                        size="small"
                        {...formik.getFieldProps("customerAddress")}
                        className={classes.textField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        multiline
                        rows={5}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid> */}

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Phone Number"
                        size="small"
                        {...formik.getFieldProps("customerMobileNum")}
                        className={classes.textField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.customerMobileNum &&
                          Boolean(formik.errors.customerMobileNum)
                        }
                        helperText={
                          formik.touched.customerMobileNum &&
                          formik.errors.customerMobileNum
                        }
                      />
                    </Grid>

                    <Grid item lg={10} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Email"
                        size="small"
                        {...formik.getFieldProps("customerEmail")}
                        className={classes.textField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        error={
                          formik.touched.customerEmail &&
                          Boolean(formik.errors.customerEmail)
                        }
                        helperText={
                          formik.touched.customerEmail &&
                          formik.errors.customerEmail
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} mt={5}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <TableContainer>
                    <Table className={classes.table}>
                                        <TableHead className={classes.tableHeaderRow}>
                                          <TableRow>
                                            <TableCell className={classes.tablheader}>
                                              <strong>Bus & Services Information</strong>
                                            </TableCell>

                                            <TableCell className={classes.tablheader}>
                                              <strong>Trip Information</strong>
                                            </TableCell>
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Quantity</strong>
                                            </TableCell> */}
                                            <TableCell className={classes.tablheader}>
                                              <strong>Price</strong>
                                            </TableCell>
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Tax</strong>
                                            </TableCell> */}
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Unit Price</strong>
                                            </TableCell> */}
                                            {/* <TableCell className={classes.tablheader}>
                                              <strong>Total</strong>
                                            </TableCell> */}
                                             <TableCell  className={classes.tablheader}
                                                                          sx={{ textAlign: "right" }}
                                                                        >
                                              <strong>Actions</strong>
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                
                
                                        <TableBody>
                      {productRows.map((product, index) => (
                        <TableRow key={index}>
                          {/* Product Details */}
                          <TableCell
                                                          component="th"
                                                          scope="row"
                                                          className={classes.tablCell}
                                                            
                                                          
                                                        >
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                              {product.productName || ""}
                            </Typography>
                            <Typography variant="body2" >
                              {product.productDescription || ""}
                            </Typography>
                            <Typography variant="body2" >
                            {product.numberOfPassengers != 0 && `${product.numberOfPassengers} Passengers`} 
                            {product.numberOfPassengers != 0 && product.busCount ? " | " : ""}
                            {product.busCount && `${product.busCount} bus`}
</Typography>


                          </TableCell>

                          {/* <TableCell
                                                          component="th"
                                                          scope="row"
                                                          className={classes.tablCell}
                                                          
                                                          
                                                        >

<Typography variant="body2" >

<Typography variant="subtitle1" component="div" gutterBottom>
  {product.transferType
    ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
        .find((key) => TransferType[key] === String(product.transferType))
    : ""}
  {product.transferTypeFrom && product.transferTypeTo ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})` : ""}
</Typography>
                            </Typography>
                            {product.departureAddress && product.departureDateTime && (
  <Typography variant="body2" component="div" gutterBottom>
    <strong>Departure:</strong>{" "}
    {product.departureAddress} <div>(
    {dayjs.isDayjs(product.departureDateTime)
      ? product.departureDateTime.format("DD-MMM-YY hh:mm A")
      : product.departureDateTime}
    )</div>
  </Typography>
)}

{product.destinationAddress && (
  <Typography variant="body2" component="div" gutterBottom>
    <>
      <strong>Destination:</strong> {product.destinationAddress}
      {product.returnDateTime && dayjs(product.returnDateTime).isValid() && (
        <>
          <br /> ({dayjs(product.returnDateTime).format("DD-MMM-YY hh:mm A")})
        </>
      )}
    </>
  </Typography>
)}
                        
                          </TableCell> */}

                          <TableCell component="th" scope="row" className={classes.tablCell}>
                            <Typography variant="body2">
                              <Typography variant="subtitle1" component="div" gutterBottom>
                                {product.transferType
                                  ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find(
                                      (key) => TransferType[key] === String(product.transferType)
                                    )
                                  : ""}
                                {product.transferTypeFrom && product.transferTypeTo
                                  ? ` (${product.transferTypeFrom} to ${product.transferTypeTo})`
                                  : ""}
                              </Typography>
                            </Typography>
                          
                            {/* Pickup Locations */}
                          {(product.pickups || [])
                            .filter(pickup => pickup.address || pickup.city)
                            .map((pickup, index, arr) => (
                              <Typography key={index} variant="body2" component="div" gutterBottom>
                            <strong>
                              Pickup{arr.length > 1 ? ` ${index + 1}` : ""}:
                            </strong>{" "}
                            {pickup.address}
                            {/* {pickup.address && pickup.city ? ", " : ""}
                            {pickup.city} */}
                            {pickup.dateTime && dayjs(pickup.dateTime).isValid() && (
                              <>
                                <br />({dayjs(pickup.dateTime).format("DD-MMM-YY hh:mm A")})
                              </>
                            )}
                          </Typography>
                            ))}
                          
                          {/* Dropoff Locations */}
                          {(product.dropoffs || [])
                            .filter(drop => drop.address || drop.city)
                            .map((drop, index, arr) => (
                              <Typography key={index} variant="body2" component="div" gutterBottom>
                                <strong>
                                  Dropoff{arr.length > 1 ? ` ${index + 1}` : ""}:
                                </strong>{" "}
                                {drop.address}
                                {/* {drop.address && drop.city ? ", " : ""}
                                {drop.city} */}
                                {drop.dateTime && dayjs(drop.dateTime).isValid() && (
                                  <>
                                    <br />({dayjs(drop.dateTime).format("DD-MMM-YY hh:mm A")})
                                  </>
                                )}
                              </Typography>
                            ))}
                          
                          {/* Return Pickups */}
                          {(product.returnPickups || [])
                            .filter(pickup => pickup.address || pickup.city)
                            .map((pickup, index, arr) => (
                              <Typography key={index} variant="body2" component="div" gutterBottom>
                                <strong>
                                  Return Pickup{arr.length > 1 ? ` ${index + 1}` : ""}:
                                </strong>{" "}
                                {pickup.address}
                                {/* {pickup.address && pickup.city ? ", " : ""}
                                {pickup.city} */}
                                {pickup.dateTime && dayjs(pickup.dateTime).isValid() && (
                                  <>
                                    <br />({dayjs(pickup.dateTime).format("DD-MMM-YY hh:mm A")})
                                  </>
                                )}
                              </Typography>
                            ))}
                          
                          {/* Return Dropoffs */}
                          {(product.returnDropoffs || [])
                            .filter(drop => drop.address || drop.city)
                            .map((drop, index, arr) => (
                              <Typography key={index} variant="body2" component="div" gutterBottom>
                                <strong>
                                  Return Dropoff{arr.length > 1 ? ` ${index + 1}` : ""}:
                                </strong>{" "}
                                {drop.address}
                                {/* {drop.address && drop.city ? ", " : ""}
                                {drop.city} */}
                                {drop.dateTime && dayjs(drop.dateTime).isValid() && (
                                  <>
                                    <br />({dayjs(drop.dateTime).format("DD-MMM-YY hh:mm A")})
                                  </>
                                )}
                              </Typography>
                            ))}
                          </TableCell>
                
                          {/* Price */}
                           <TableCell
                                                           component="th"
                                                           scope="row"
                                                           className={classes.tablCell}
                                                         >
                          <Typography variant="body1">
                  ${product.price != null ? product.price.toFixed(2) : "0.00"}
                </Typography>
                
                          </TableCell>
                
                          {/* Tax */}
                           {/* <TableCell
                                                           component="th"
                                                           scope="row"
                                                           className={classes.tablCell}
                                                         >
                            <Typography variant="body1">
                              {product.taxAmount ? `${product.taxAmount.toFixed(2)}` : "0.00"}
                            </Typography>
                          </TableCell> */}
                
                          {/* Total */}
                          {/* <TableCell
                                                          component="th"
                                                          scope="row"
                                                          className={classes.tablCell}
                                                        >
                            <Typography variant="body1">
                              ${product.unitTotalWithDiscount ? product.unitTotalWithDiscount.toFixed(2) : "0.00"}
                            </Typography>
                          </TableCell> */}
                
                          {/* Actions */}
                          <TableCell  scope="row" className={classes.tablCell}
                                                         >
                                                           <Grid
                                                             container
                                                             spacing={1}
                                                             sx={{
                                                               display: "flex",
                                                               justifyContent: "flex-end",
                                                             }}
                                                           >
                
                                                                 <Grid item>
                            <IconButton
                              color="primary"
                              onClick={() => handleEditRow(index)}
                            >
                              <FaEdit  style={{ fontSize: 18 }}/>
                            </IconButton>
                            </Grid>
                            <Grid item>
                            <IconButton
                              color="primary"
                              onClick={() => handleDeleteRow(index)}
                            >
                              <FaTrash style={{ fontSize: 16 }} />
                            </IconButton>
                            </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      py={2}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        className={classes.addButton}
                        onClick={handleAddRow}
                      >
                        Trip
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

             <Dialog open={popupOpen} onClose={() => setPopupOpen(false)}  maxWidth="lg">
                        <DialogTitle>{editIndex !== null ? "Trip Info" : "Trip Info"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>

     
         <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container alignItems="center">
          <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                           Product Name 
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
          size="small"
          fullWidth
          value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productName}
          onChange={(e) => handleProductNameChange(editIndex !== null ? editIndex : productRows.length - 1, e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CiSearch className={classes.searchWidgetIcon} />
              </InputAdornment>
            ),
            classes: {
              root: classes.formControlListQuto,
              notchedOutline: classes.notchedOutline,
            },
          }}
          onFocus={() => setShowDropdownProductIndex(editIndex !== null ? editIndex : productRows.length - 1)}
        />

{showDropdownProductIndex === (editIndex !== null ? editIndex : productRows.length - 1) && (
          <Paper className={classes.dropdownPaper}>
            {productIsLoading ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                <CircularProgress size={24} />
              </div>
            ) : (
              productList.length > 0 &&
              productList.map((Product) => (
                <MenuItem
                  key={Product.id}
                  onClick={() => handleProductSelect(Product, editIndex !== null ? editIndex : productRows.length - 1)}
                >
                  <img
                     src={Product.productImg ?`${LARAVEL_API_URL}/${String(Product.productImg)}` : placeholderImage}
                 
                   // src={String(Product.productImg)}
                    className={classes.quoteImgSelctMenu}
                    alt="img"
                  />
                  {Product.productName}
                </MenuItem>
              ))
            )}
          </Paper>
        )}
          </Grid>
          </Grid>
          </Grid>


                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         No of Passengers
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <TextField
                          placeholder="Enter No of passengers .."
                          size="small"
                          type="number"
                          //value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.numberOfPassengers}
                            value={
  productRows[editIndex !== null ? editIndex : productRows.length - 1]?.numberOfPassengers === 0
    ? ""
    : productRows[editIndex !== null ? editIndex : productRows.length - 1]?.numberOfPassengers
}
                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "numberOfPassengers",  Number(e.target.value))}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            }, inputProps: { min: 0 }, 
                           
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                        </Grid>
                    </Grid>
                  </Grid>

                  
 <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                          Transfer Type
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                        <TextField  select
                          size="small"
                          value={
                            productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferType ?? ""
                          }

                          onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "transferType", String(e.target.value))}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        >
                              <MenuItem value="" disabled>   Select an option </MenuItem>
                                            {Object.entries(TransferType).map(
                                              ([key, value], index) => (
                                                <MenuItem
                                                  key={index}
                                                  value={value}
                                                >
                                                  {key}
                                                </MenuItem>
                                              )
                                            )} </TextField>
                      </Grid>
                    </Grid>
                  </Grid>





  {/* ===================== Outbound Pickups ===================== */}
  <Grid item xs={12}>
    <Typography variant="h5" gutterBottom>Pickups</Typography>
  </Grid>

  {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.pickups || []).map((pickup, pickupIndex) => (
    <React.Fragment key={pickupIndex}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Pickup {pickupIndex + 1}</Typography>
      </Grid>

      {/* Address */}
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <TextField
          placeholder="Enter Address"
          size="small"
          value={pickup.address}
          onChange={(e) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "pickups", pickupIndex, "address", e.target.value)
          }
          fullWidth
        />
      </Grid>

      {/* City */}
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Autocomplete
          options={canadianCities}
          value={pickup.city || ""}
          onChange={(event, newValue) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "pickups", pickupIndex, "city", newValue ?? "")
          }
          renderInput={(params) => <TextField {...params} placeholder="Enter City" size="small" />}
        />
      </Grid>

      {/* Date */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={pickup.dateTime}
            minDate={dayjs()}
            onChange={(date) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "pickups", pickupIndex, "dateTime", date)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Date" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Time */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={pickup.dateTime}
            onChange={(time) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "pickups", pickupIndex, "dateTime", time)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Time" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Delete */}
      <Grid item lg={1} md={1} sm={12} xs={12}>
        {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.pickups?.length || 0) > 1 && (
          <IconButton
            color="error"
            size="small"
            onClick={() => removeArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "pickups", pickupIndex)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Grid>
    </React.Fragment>
  ))}

  <Grid item xs={12}>
    <Button
      size="small"
      variant="outlined"
      onClick={() => addArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "pickups")}
    >
      + Add Pickup
    </Button>
  </Grid>

  {/* ===================== Outbound Dropoffs ===================== */}
  <Grid item xs={12}>
    <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>Dropoffs</Typography>
  </Grid>

  {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.dropoffs || []).map((drop, dropIndex) => (
    <React.Fragment key={dropIndex}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Dropoff {dropIndex + 1}</Typography>
      </Grid>

      {/* Address */}
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <TextField
          placeholder="Enter Address"
          size="small"
          value={drop.address}
          onChange={(e) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "dropoffs", dropIndex, "address", e.target.value)
          }
          fullWidth
        />
      </Grid>

      {/* City */}
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Autocomplete
          options={canadianCities}
          value={drop.city || ""}
          onChange={(event, newValue) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "dropoffs", dropIndex, "city", newValue ?? "")
          }
          renderInput={(params) => <TextField {...params} placeholder="Enter City" size="small" />}
        />
      </Grid>

      {/* Date */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={drop.dateTime}
            minDate={dayjs()}
            onChange={(date) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "dropoffs", dropIndex, "dateTime", date)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Date" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Time */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={drop.dateTime}
            onChange={(time) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "dropoffs", dropIndex, "dateTime", time)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Time" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Delete */}
      <Grid item lg={1} md={1} sm={12} xs={12}>
        {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.dropoffs?.length || 0) > 1 && (
          <IconButton
            color="error"
            size="small"
            onClick={() => removeArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "dropoffs", dropIndex)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Grid>
    </React.Fragment>
  ))}

  <Grid item xs={12}>
    <Button
      size="small"
      variant="outlined"
      onClick={() => addArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "dropoffs")}
    >
      + Add Dropoff
    </Button>
  </Grid>




  {/* ===================== Return Pickups ===================== */}

  {productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferType !== TransferType.OneWayTransfer && (
    <>

      <Grid item xs={12}>
      <FormControlLabel
        control={
          <Checkbox
            checked={
              productRows[editIndex !== null ? editIndex : productRows.length - 1]?.useSameAsOutbound || false
            }
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...productRows];
  const product = updated[editIndex !== null ? editIndex : productRows.length - 1];

  product.useSameAsOutbound = e.target.checked;

  if (e.target.checked) {

    // Return pickup = outbound dropoff
  product.returnPickups =
  product.dropoffs?.map(d => ({
    address: d.address,
    city: d.city,
    dateTime: null
  })) || [];

product.returnDropoffs =
  product.pickups
    ?.slice()        // create copy
    .reverse()       // reverse order
    .map(p => ({
      address: p.address,
      city: p.city,
      dateTime: null
    })) || [];

  } else {
    // Allow manual entry
    product.returnPickups = [{ address: "", city: "", dateTime: null }];
    product.returnDropoffs = [{ address: "", city: "", dateTime: null }];
  }

  setProductRows(updated);
}}
          />
        }
        label="Return Trip same"
      />
    </Grid>

  <Grid item xs={12}>
    <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>Return Pickups</Typography>
  </Grid>

  {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.returnPickups || []).map((pickup, pickupIndex) => (
    <React.Fragment key={pickupIndex}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Return Pickup {pickupIndex + 1}</Typography>
      </Grid>

      {/* Address */}
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <TextField
          placeholder="Enter Address"
          size="small"
          value={pickup.address}
          onChange={(e) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnPickups", pickupIndex, "address", e.target.value)
          }
          fullWidth
        />
      </Grid>

      {/* City */}
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Autocomplete
          options={canadianCities}
          value={pickup.city || ""}
          onChange={(event, newValue) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnPickups", pickupIndex, "city", newValue ?? "")
          }
          renderInput={(params) => <TextField {...params} placeholder="Enter City" size="small" />}
        />
      </Grid>

      {/* Date */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={pickup.dateTime}
            minDate={dayjs()}
            onChange={(date) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnPickups", pickupIndex, "dateTime", date)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Date" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Time */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={pickup.dateTime}
            onChange={(time) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnPickups", pickupIndex, "dateTime", time)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Time" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Delete */}
      <Grid item lg={1} md={1} sm={12} xs={12}>
        {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.returnPickups?.length || 0) > 1 && (
          <IconButton
            color="error"
            size="small"
            onClick={() => removeArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "returnPickups", pickupIndex)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Grid>
    </React.Fragment>
  ))}

  <Grid item xs={12}>
    <Button
      size="small"
      variant="outlined"
      onClick={() => addArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "returnPickups")}
    >
      + Add Return Pickup
    </Button>
  </Grid>

  {/* ===================== Return Dropoffs ===================== */}
  <Grid item xs={12}>
    <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>Return Dropoffs</Typography>
  </Grid>

  {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.returnDropoffs || []).map((drop, dropIndex) => (
    <React.Fragment key={dropIndex}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Return Dropoff {dropIndex + 1}</Typography>
      </Grid>

      {/* Address */}
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <TextField
          placeholder="Enter Address"
          size="small"
          value={drop.address}
          onChange={(e) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnDropoffs", dropIndex, "address", e.target.value)
          }
          fullWidth
        />
      </Grid>

      {/* City */}
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Autocomplete
          options={canadianCities}
          value={drop.city || ""}
          onChange={(event, newValue) =>
            handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnDropoffs", dropIndex, "city", newValue ?? "")
          }
          renderInput={(params) => <TextField {...params} placeholder="Enter City" size="small" />}
        />
      </Grid>

      {/* Date */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={drop.dateTime}
            minDate={dayjs()}
            onChange={(date) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnDropoffs", dropIndex, "dateTime", date)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Date" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Time */}
      <Grid item lg={2} md={2} sm={6} xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={drop.dateTime}
            onChange={(time) =>
              handleFieldChangeArray(editIndex !== null ? editIndex : productRows.length - 1, "returnDropoffs", dropIndex, "dateTime", time)
            }
            slotProps={{ textField: { size: "small", fullWidth: true, placeholder: "Select Time" } }}
          />
        </LocalizationProvider>
      </Grid>

      {/* Delete */}
      <Grid item lg={1} md={1} sm={12} xs={12}>
        {(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.returnDropoffs?.length || 0) > 1 && (
          <IconButton
            color="error"
            size="small"
            onClick={() => removeArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "returnDropoffs", dropIndex)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Grid>
    </React.Fragment>
  ))}

  <Grid item xs={12}>
    <Button
      size="small"
      variant="outlined"
      onClick={() => addArrayItem(editIndex !== null ? editIndex : productRows.length - 1, "returnDropoffs")}
    >
      + Add Return Dropoff
    </Button>
  </Grid>
</>
)}


 {/* {productRows[editIndex !== null ? editIndex : productRows.length - 1]?.transferType !== TransferType.OneWayTransfer && (
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid  item xs={12}>
                        <Typography variant="subtitle1">
                         Return date & time
                        </Typography>
                      </Grid>
                      <Grid  item xs={12}>
                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DateTimePicker
                                         value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.returnDateTime}
                                         onChange={(value) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "returnDateTime", value)}
                                          // viewRenderers={{
                                          //   hours: renderTimeViewClock,
                                          //   minutes: renderTimeViewClock,
                                          //   seconds: renderTimeViewClock,
                                          // }}
                                          minDateTime={
                                            productRows[editIndex !== null ? editIndex : productRows.length - 1]?.departureDateTime
                                            ? dayjs(productRows[editIndex !== null ? editIndex : productRows.length - 1]?.departureDateTime)
                                            : undefined }
                                          slotProps={{
                                            textField: {
                                              placeholder:
                                                "Return Date & Time",
                                              size: "small",
                                              sx: { width: "100%" },
                                              error: !!errors.returnDateTime, // Show error if exists
                                              helperText: errors.returnDateTime || "", // Display error message
                                              InputProps: {
                                                sx: { fontSize: 14 },
                                                classes: {
                                                  root: classes.textFieldQuote,
                                                },
                                              },
                                              InputLabelProps: {
                                                sx: { fontSize: 14 },
                                              },
                                            },
                                          }}
                                        />
                                      </LocalizationProvider>
                        </Grid>
                        </Grid>
                        </Grid>   
 )} */}
                                          <Grid item  lg={12} md={12} sm={12} xs={12}>
                                         
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                     
                                          >
                                            {priceHistoryIsLoading && (
                                              <div
                                                style={{
                                                  textAlign: "center",
                                                  padding: "10px",
                                                }}
                                              >
                                                <CircularProgress size={24} />
                                              </div>
                                            )}
                                            {nextPrice && (
                                              <Alert
                                                icon={false}
                                                severity="success"
                                                sx={{ marginBottom: "1px" }}
                                              >
                                                <Typography>
                                                
                                                 <span >
                                                   L.Price: {nextPrice} ({busCount} bus{busCount !== 1 ? "es" : ""})
                                                 </span>
                                                 <span style={{ marginLeft: "8px" }}>
                                                   A.Price: {averagePrice}
                                                 </span>
                                               </Typography>

                                                <Typography
                                                  component="span"
                                                  sx={{ fontSize: "12px" }}
                                                >
                                                  {updated_at
                                                    ? new Date(
                                                        updated_at
                                                      ).toLocaleDateString()
                                                    : ""}
                                                  {"   "}
                                                  <Typography
                                                    component="span"
                                                    sx={{
                                                      color: "blue",
                                                      fontWeight: "bold",
                                                      cursor: "pointer",
                                                      textDecoration:
                                                        "underline",
                                                      marginLeft: "8px",
                                                      fontSize: "12px" 
                                                    }}
                                                    onClick={() =>
                                                      window.open(
                                                        `/work-order/history/${priceId}`,
                                                        "_blank"
                                                      )
                                                    }
                                                  >
                                                    {quoteWorkOrderNo}
                                                  </Typography>
                                                </Typography>
                                              </Alert>
                                            )}

{priceHistoryError && currentIndex !== null && (
  <Alert icon={false} severity="error">
    Error fetching price history for{" "}
    {productRows[currentIndex]?.productName}.
  </Alert>
)}      </Grid>
</Grid> 

                                       
               
             
                <Grid item lg={2} md={2} sm={6} xs={12}>
                                   <Grid container alignItems="center">
                                     <Grid  item xs={12}>
                                       <Typography variant="subtitle1">
                                        Qty
                                       </Typography>
                                     </Grid>
                                     <Grid  item xs={12}>
                                     <TextField
                                         placeholder="Enter qty .."
                                         size="small"
                                         type="number"
                                         value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.busCount}
                                         onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "busCount",  Number(e.target.value))}
                                         className={classes.discriptionTextField}
                                         InputProps={{
                                           sx: {
                                             fontSize: 14,
                                           },
                                            inputProps: { min: 0 }, 
                                       
                                         }}
                                         InputLabelProps={{
                                           sx: {
                                             fontSize: 14,
                                           },
                                         }}
                                       />
                                       </Grid>
                                   </Grid>
                                 </Grid>
               
                                 
                       <Grid item lg={3} md={3} sm={6} xs={12}>
                               <Grid container alignItems="center">
                       
                                 <Grid item lg={12} md={12} sm={12} xs={12}>
                                                 <Typography variant="subtitle1">
                                                  Price 
                                                  </Typography>
                                                  </Grid>
                                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <TextField
                         size="small"
                         type="number"
                         fullWidth
                         // value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price}
                         onChange={(e) => handlePriceChange(editIndex !== null ? editIndex : productRows.length - 1, Math.max(0, Number(e.target.value)))}
                         value={
                 productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price === 0
                   ? ""
                   : productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price
               }
                        
                       />
                       
                                 </Grid>
                                 </Grid>
                                 </Grid>
                       
                                 <Grid item lg={6} md={6} sm={12} xs={12}>
                         <Grid container alignItems="flex-end" spacing={2} style={{ height: "100%" }}>
                           {/* Tax Dropdown */}
                           <Grid item lg={6} md={6} sm={6} xs={12}>
                             <Typography variant="subtitle1">Tax</Typography>
                             <TextField
                               select
                               size="small"
                               fullWidth
                               value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.tax}
                               onChange={(e) => {
                                 const taxPercentage = Number(e.target.value);
                                 const productPrice =
                                   productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price || 0;
                                 const taxAmount = productPrice * (taxPercentage / 100);
                       
                                 handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "tax", taxPercentage);
                                 handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "taxAmount", taxAmount);
                               }}
                             >
                               <MenuItem value={0}>No Tax</MenuItem>
                               {taxList &&
                                 taxList.map((tax) => (
                                   <MenuItem key={tax.id} value={tax.percentage}>
                                     {tax.taxName} - {tax.percentage}%
                                   </MenuItem>
                                 ))}
                             </TextField>
                           </Grid>
                       
                           {/* Tax Amount */}
                           <Grid
                             item
                             lg={6}
                             md={6}
                             sm={6}
                             xs={12}
                             style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}
                           >
                             {productRows[editIndex !== null ? editIndex : productRows.length - 1]?.tax > 0 && (
                               <Typography
                                 variant="body2"
                                 style={{
                                   display: "flex",
                                   alignItems: "center", // Align content to the bottom
                                   padding:'10px',
                                 }}
                               >
                                 Tax Amount: $
                                 {productRows[editIndex !== null ? editIndex : productRows.length - 1]?.taxAmount?.toFixed(2) || "0.00"}
                               </Typography>
                             )}
                           </Grid>
                         </Grid>
                       </Grid>

                       <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <Grid container alignItems="center">
                                             <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <Typography variant="subtitle1">
                                                 Description :
                                               </Typography>
                                             </Grid>
                                             <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <TextField
                                                 placeholder="Enter Description .."
                                                 size="small"
                                                 multiline
                                                 rows={6}
                                                 value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productDescription}
                                                 onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "productDescription", e.target.value)}
                                                 className={classes.discriptionTextField}
                                                 InputProps={{
                                                   sx: {
                                                     fontSize: 14,
                                                   },
                                                 }}
                                                 InputLabelProps={{
                                                   sx: {
                                                     fontSize: 14,
                                                   },
                                                 }}
                                               />
                                             </Grid>
                                           </Grid>
                                         </Grid>
                       
               

        </Grid>
        </DialogContent>
      <DialogActions sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={handleCancel}

                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={<SaveAltIcon />}
                      className={classes.addButton}
                      onClick={handleSaveProduct}
                      // onClick={() => {
                      //   if (editIndex !== null) {
                      //     // Edit product logic
                      //     const updatedRows = [...productRows];
                      //     updatedRows[editIndex] = productRows[editIndex];
                      //     setProductRows(updatedRows);
                      //     //console.log(updatedRows);
                      //   } else {
                      //     // Add new product logic
                      //     setProductRows([...productRows]);
                      //    // setProductRows([...productRows, productRows[productRows.length - 1]]);
                      //     //console.log([...productRows]);
                      //   }
                      //   setPopupOpen(false);
                      // }}
                    >
               {editIndex !== null ? 'Update' : 'Save'}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>

    </Dialog>

            
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={3}>
                <Grid item lg={8} md={8} sm={12} xs={12}>
                  <Grid container spacing={3} alignItems="center">
                    {discounts.map((discount, index) => (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={1}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            
                            <TextField
                              placeholder="Description"
                              size="small"
                              value={discount.description}
                              onChange={(e) =>
                                handleDiscountChange(
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                              InputProps={{
                                readOnly: true, 
                                sx: {
                                  fontSize: 14,
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              InputLabelProps={{
                               
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              className={classes.textField}
                            />
                          </Grid>
                          <Grid item lg={3} md={3} sm={3} xs={3}>
                            <TextField
                              placeholder="Discount"
                              size="small"
                              type="number"
                              value={discount.value}
                              onChange={(e) =>
                                handleDiscountChange(
                                  index,
                                  "value",
                                  Number(e.target.value)
                                )
                              }
                              InputProps={{
                                readOnly: true, 
                                sx: {
                                  fontSize: 14,
                                },
                                inputProps: { min: 0 },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              className={classes.textField}
                            />
                          </Grid>
                    
                          <Grid item lg={3} md={3} sm={3} xs={3} sx={{ display: "flex", gap: 1 }}>
  <Grid item>
    <IconButton
      color="primary"
      style={{ fontSize: 16 }}
      onClick={() => handleOpenDialog(index)}
    >
      <FaEdit />
    </IconButton>
  </Grid>
  <Grid item>
    <IconButton
      color="primary"
      onClick={() => handleDeleteDiscount(index)}
      style={{ fontSize: 16 }}
    >
      <FaTrash />
    </IconButton>
  </Grid>
</Grid>

                          </Grid>
                     
                      </Grid>
                    ))}
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      py={2}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        className={classes.addButton}
                        onClick={() => handleOpenDialog(null)} 
                      >
                        Discount
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={6}
                          alignContent={"center"}
                          textAlign={"right"}
                        >
                          <Typography className={classes.h5}>
                            Sub Total :
                          </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <TextField
                            placeholder="Discount"
                            size="small"
                            value={subTotal.toFixed(2)}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.textFieldQuote,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={6}
                          alignContent={"center"}
                          textAlign={"right"}
                        >
                          <Typography className={classes.h5}>
                            Total Discount :
                          </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <TextField
                            placeholder="Discount"
                            size="small"
                            value={totalDiscount.toFixed(2)}
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.textFieldQuote,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12}>
                                          <Grid container spacing={1}>
                                            <Grid
                                              item
                                              lg={6}
                                              md={6}
                                              sm={6}
                                              xs={6}
                                              alignContent={"center"}
                                              textAlign={"right"}
                                            >
                                              <Typography className={classes.h5}>
                                                HST
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                              <TextField
                                                placeholder="HST"
                                                sx={{ width: "100%" }}
                                                size="small"
                                                value={taxAmount.toFixed(2)}
                                                className={classes.textField}
                                                InputProps={{
                                                  readOnly: true,
                                                  sx: {
                                                    fontSize: 14,
                                                  },
                                                  startAdornment: (
                                                    <InputAdornment position="start">
                                                      $
                                                    </InputAdornment>
                                                  ),
                                                  classes: {
                                                    root: classes.textFieldQuote,
                                                    notchedOutline: classes.notchedOutline,
                                                  },
                                                }}
                                                InputLabelProps={{
                                                  sx: {
                                                    fontSize: 14,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={6}
                          xs={6}
                          alignContent={"center"}
                          textAlign={"right"}
                        >
                          <Typography className={classes.h5}>
                            Grand Total :
                          </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <TextField
                            placeholder="Discount"
                            size="small"
                            value={
                              isNaN(grandTotalEithDiscount)
                                ? "0.00"
                                : (grandTotalEithDiscount ?? 0).toFixed(2)
                            } // Ensure value is a valid number
                            className={classes.textField}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                fontSize: 14,
                              },
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                              classes: {
                                root: classes.textFieldQuote,
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1">Remarks on invoice :</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Enter Remarks on invoice .."
                        size="small"
                        multiline
                        rows={8}
                        {...formik.getFieldProps("quoteWorkOrderCustomerMemo")}
                        className={classes.discriptionTextField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1">Remarks on office use :</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        placeholder="Enter Remarks on office use"
                        size="small"
                        multiline
                        rows={8}
                        {...formik.getFieldProps(
                          "quoteWorkOrderCustomerRemark"
                        )}
                        className={classes.discriptionTextField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ borderBottom: 2, paddingBottom: 5 }}
              className={classes.titleGrid}
            >
              <Grid container spacing={3}>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={cancelFunction}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>

                  <Button
                    variant="contained"
                    startIcon={<SaveAltIcon />}
                    className={classes.addButton}
                    onClick={() => formik.handleSubmit()}
                    disabled={!formValid || isLoading}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Dialog open={dialogOpen} onClose={handleCloseDialog}>
            <Grid className={classes.Dialog}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                  {editingIndex !== null ? "Edit Discount" : "Add Discount"}
                  </Typography>
                </Grid>
              </Grid>
              <DialogContent>
                <Grid container spacing={3}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Discount :</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Invoice Number :"
                          size="small"
                          value={discountValue}
                          onChange={(e) =>
                            setDiscountValue(Number(e.target.value))
                          }
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                            startAdornment: (
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                            ),
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                          Description :
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Description .."
                          size="small"
                          multiline
                          rows={8}
                          value={discountDescription}
                          onChange={(e) =>
                            setDiscountDescription(e.target.value)
                          }
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={handleCloseDialog}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={<SaveAltIcon />}
                      className={classes.addButton}
                      onClick={handleSaveDiscount}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Grid>
          </Dialog>

          {openCompany && (
            <NewCompanyPopUp
              handleCloseDialog={() => setOpenCompany(false)}
              openModel={openCompany}
            />
          )}

          <Dialog open={openD} onClose={handleCloseDialog}>
            <Grid className={classes.Dialog}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Confirm Action
                  </Typography>
                </Grid>
              </Grid>
              <DialogContent>
                <DialogContentText sx={{ pt: 3 }}>
                  Are you sure you want to proceed with invoice success?

                   {/* <Grid item lg={12} md={12} sm={12} xs={12} sx={{mt:2}}>
                                      <TextField
                              label="Enter PO Number"
                              variant="outlined"
                              size="small"
                              className={classes.textField}
                              value={poNumber}
                              onChange={(e) => setPoNumber(e.target.value)}
                            />
                            </Grid> */}
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<CheckCircleOutlineSharpIcon />}
                      className={classes.addButton}
                      onClick={handleConfirmDialog}
                    >
                      Yes
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Grid>
          </Dialog>
        </form>
      </Card>
    </div>
  );
};

export default Index;
